import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`shorteval-modal ${_ctx.classDiv ? _ctx.classDiv : ''}`)
  }, [
    _createVNode(_component_el_button, {
      plain: _ctx.plain,
      type: _ctx.type,
      size: _ctx.size,
      class: _normalizeClass(_ctx.btnClass),
      onClick: _ctx.open
    }, {
      default: _withCtx(() => [
        (_ctx.iconComponents && _ctx.iconComponents[_ctx.iconBefore])
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              size: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponents[_ctx.iconBefore])))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.iconPathBefore)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: _normalizeClass('shorteval-modal-image before'),
              src: _ctx.iconPathBefore,
              alt: _ctx.title
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        (_ctx.btnTitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass('shorteval-modal-text'),
              innerHTML: _ctx.btnTitle
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.iconPathAfter)
          ? (_openBlock(), _createElementBlock("img", {
              key: 3,
              class: _normalizeClass('shorteval-modal-image after'),
              src: _ctx.iconPathAfter,
              alt: _ctx.title
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.iconComponents && _ctx.iconComponents[_ctx.iconAfter])
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 4,
              size: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponents[_ctx.iconAfter])))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["plain", "type", "size", "class", "onClick"])
  ], 2))
}